/**
 * Project mode
 */
export const IS_PRODUCTION = process.env.NODE_ENV === 'production';

export const APPNAME = process.env.VUE_APP_NAME;

export const IS_MOBILE =
  process.env.VUE_APP_MOBILE === 'android' || process.env.VUE_APP_MOBILE === 'ios';

/**
 * Connect configuration
 *
 * Get from enviroment file
 */
export const CONNECT = {
  DEV: {
    API_URL: process.env.VUE_APP_API_URL_DEV,
  },
  PRE: {
    API_URL: process.env.VUE_APP_API_URL_PRE,
  },
  PROD: {
    API_URL: process.env.VUE_APP_API_URL_PROD,
  },
  SCOPE: process.env.VUE_APP_API_SCOPE,
  API_VERSION: process.env.VUE_APP_API_VERSION,
  SOCKET_PATH: process.env.VUE_APP_SOCKET_PATH,
};

/**
 * App configuration
 */
export const CONFIG = {
  ARCADE_MODE_TIME: 300,
  HOUR24: process.env.VUE_APP_HOUR24 === 'true',
  SHOW_SUPPORT_EMAIL: process.env.VUE_APP_SHOW_SUPPORT_EMAIL === 'true',
  MONDAY_FIRSTDAY: process.env.VUE_APP_MONDAY_FIRSTDAY === 'true',
  DEFAULT_SCHEDULES_DAYS: process.env.VUE_APP_DEFAULT_SCHEDULES_DAYS,
  TEST_ACTIONS: process.env.VUE_APP_TEST_ACTIONS === 'true',
  INIT_MESSAGE: process.env.VUE_APP_INIT_MESSAGE === 'true',
  SEND_COORD: process.env.VUE_APP_SEND_COORD === 'true',
  MODBUS: process.env.VUE_APP_MODBUS === 'true',
  AIRTOOLS: process.env.VUE_APP_AIRTOOLS === 'true',
  DEFAULT_UNITS: parseInt(process.env.VUE_APP_DEFAULT_UNITS, 10),
  SCENES: process.env.VUE_APP_SCENES === 'true',
  WEATHER: process.env.VUE_APP_WEATHER === 'true',
  USERS_PENDING: process.env.VUE_APP_USERS_PENDING === 'true',
  ORDER: process.env.VUE_APP_ORDER === 'true',
  DEVICES: process.env.VUE_APP_DEVICES === 'true',
  FALLBACK: process.env.VUE_APP_FALLBACK === 'true',
};

/**
 * App languages
 *
 * es: 'Español'
 * en: 'English'
 * fr: 'Français'
 * it: 'Italiano'
 * de: 'Deutsch'
 * pt: 'Portugues'
 */
const languages = {};
if (process.env.VUE_APP_LANGUAGE_ES === 'true') languages.es = 'Español';
if (process.env.VUE_APP_LANGUAGE_EN === 'true') languages.en = 'English';
if (process.env.VUE_APP_LANGUAGE_FR === 'true') languages.fr = 'Français';
if (process.env.VUE_APP_LANGUAGE_IT === 'true') languages.it = 'Italiano';
if (process.env.VUE_APP_LANGUAGE_DE === 'true') languages.de = 'Deutsch';
if (process.env.VUE_APP_LANGUAGE_PT === 'true') languages.pt = 'Portugues';

export const LANGUAGE = {
  DEFAULT: 'en',
  FALLBACK: 'en',
  LANGUAGES: languages,
};

/**
 * Modes values
 */
export const MODES = {
  AUTO: 1,
  COOLING: 2,
  HEATING: 3,
  FAN: 4,
  DRY: 5,
};

/**
 * Units values
 */
export const UNITS = {
  CELSIUS: 0,
  FARENHEIT: 1,
};

/**
 * Slats modes
 */
export const SLATS_MODE = {
  AUTO: 8,
  SWING: 9,
};

/**
 * Num of icons
 */
export const ICONS = {
  ACS: 9,
  DEFAULT: 21,
  SCENES: 30,
};

/**
 * Users Type
 */
export const USER_TYPE = {
  ADVANCED: 'advanced',
  BASIC: 'basic',
};

/**
 * IQ Mode
 */
export const IQ_MODE = {
  OFF: 0,
  ON: 1,
  AUTO: 2,
};

/**
 * IAQ Range
 */
export const IAQ = {
  MIN: 0,
  MAX: 100,
  LOW: 25,
  HIGH: 50,
};

/**
 * Wifi status
 *
 * 1 - Device try to connect to the WiFi network
 * 2 - Device success connected to the Wifi network, now device try to connect to the cloud
 * 3 - Success connected device to the Cloud
 * 0 or 4 - Device could't connect to the WiFi network, it could be by the password
 *          If device was connected to the WiFi network, it lose the connection
 * default - Some times device is very slow and don't return any data => status = undefined
 */
export const WIFI_STATUS = {
  DISCONNECTED: 0,
  CONNECTING: 1,
  WIFI_CONNECTED: 2,
  CLOUD_CONNECTED: 3,
};

/**
 * TAI TH modes
 */
export const TAI = {
  AIR: true,
  WATER: false,
};

/**
 * REGEX expressions
 */
export const REGEX = {
  DEVICES_NAMES: /^[a-zA-Z0-9 ñàâäáåãèêëéìîïíòôóöõœùûüúÿçøæœÑÀÂÄÁÅÃÈÉÊËÉÎÏÍÔÓÖÕŒÙÛÜÚŸÇßØÆ]{1,15}$/,
  INSTALLATIONS_NAMES:
    /^[a-zA-Z0-9 ñàâäáåãèêëéìîïíòôóöõœùûüúÿçøæœÑÀÂÄÁÅÃÈÉÊËÉÎÏÍÔÓÖÕŒÙÛÜÚŸÇßØÆ]{1,15}$/,
  SCHEDULES_NAMES: /^.{1,15}$/,
  SCENES_NAMES: /^.{1,15}$/,
};

/**
 * Bluetooth configuration
 */
export const BLUETOOTH = {
  MIN_LEVEL_SIGNAL: -75,
  MAX_TIME_SCAN_DEVICES: 5000,
  SERVICE_UUID: 'AABB',
  CHARACTERISTIC_UUID: 'C300',
  MAX_TIME_GET_DATA: 60000,
  SLEEP_TIME_BETWEEN_REQUEST: 2000,
};

/**
 * Coverage BLUETOOTH values
 */
export const COVERAGE = {
  HIGHEST: -56,
  HIGH: -67,
  MEDIUM: -78,
  LOW: -89,
  LOWEST: -100,
};

/**
 * Names of webservers altherma
 */
export const ALTHERMA = ['AZWSDA2', 'AZWSDK2'];

/**
 * Third party
 */
export const DEVICES_SHORT = {
  hw: 'honeywell',
  ecob: 'ecobee',
  nest: 'nest',
};

export const DEVICES = ['honeywell', 'ecobee', 'nest'];

/**
 * Temp Sensor
 */
export const TEMP_SENSOR = {
  INDOOR: 0,
  THERMOSTAT: 1,
  MIX: 2,
};

/**
 * Docs url
 */
export const DOCS = {
  LEGAL: {
    EN: process.env.VUE_APP_DKN_LEGAL_EN,
    ES: process.env.VUE_APP_DKN_LEGAL_ES,
    FR: process.env.VUE_APP_DKN_LEGAL_FR,
    IT: process.env.VUE_APP_DKN_LEGAL_IT,
    PT: process.env.VUE_APP_DKN_LEGAL_PT,
    DE: process.env.VUE_APP_DKN_LEGAL_DE,
  },
  PRIVACY: {
    EN: process.env.VUE_APP_DKN_PRIVACY_EN,
    ES: process.env.VUE_APP_DKN_PRIVACY_ES,
    FR: process.env.VUE_APP_DKN_PRIVACY_FR,
    IT: process.env.VUE_APP_DKN_PRIVACY_IT,
    PT: process.env.VUE_APP_DKN_PRIVACY_PT,
    DE: process.env.VUE_APP_DKN_PRIVACY_DE,
  },
  TERMS: {
    EN: process.env.VUE_APP_DKN_TERMS_EN,
    ES: process.env.VUE_APP_DKN_TERMS_ES,
    FR: process.env.VUE_APP_DKN_TERMS_FR,
    IT: process.env.VUE_APP_DKN_TERMS_IT,
    PT: process.env.VUE_APP_DKN_TERMS_PT,
    DE: process.env.VUE_APP_DKN_TERMS_DE,
  },
};
